const steps = [
  {
    icon: "ri-settings-4-line",
    title: "锁定入口",
    text: "从「直达入口」选一个平台出发，优先进入热搜榜、热榜或热议频道，先看清整体风向。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "跟准话题",
    text: "锁定话题标签或事件关键词，在各平台统一搜索，顺着同一词条跟完整条讨论链路。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多方核对",
    text: "同一件事在不同平台会有不同视角，多看几处相互印证，先别急着下结论。",
  },
  {
    icon: "ri-speak-line",
    title: "理性围观",
    text: "不轻信未经证实的传闻，不造谣不传谣，尊重当事人隐私，再表达你自己的观点。",
  },
];

export default function Guide() {
  return (
    <section id="zhinan" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-900">
            <i className="ri-map-2-line" aria-hidden="true"></i>
            围观指南
          </p>
          <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
            一条清晰的围观路线图
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            热点不是越快越好，看懂脉络更重要。跟着这套路线，从发现到理性表达，每一步都更从容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative flex flex-col rounded-2xl border border-background-200/80 bg-background-100 p-6">
              <span className="font-heading absolute right-5 top-5 text-5xl font-black text-background-300/70">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-lg font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}